import React from 'react'

const EventCalendarPopup = (props) => {
  return (
    <>
      <div className="ec-container d-flex align-items-center justify-content-center" onClick={() => {props.setShowEventCalendarPopup(false);}}>
        <div className="ec-wrapper">
          <div className="ec-header">
            <h4 className="pe-5">{props.event.title}<span className="ec-popup-close-btn lh-1" onClick={() => {props.setShowEventCalendarPopup(false);}}>&#x2715;</span></h4>
          </div>
          <div className="ec-body">
            <p>{props.event.description}</p>
            <p>
              <i className="icon-calendar-2-line"></i>&nbsp;&nbsp;{props.event.dateTime}
            </p>
            <div className="ec-footer d-flex flex-column flex-md-row align-items-center justify-content-between">
              <a href={props.event.url} target="_blank" rel="noreferrer" className="edu-btn btn-primary">Learn More & Get Ticket</a>
              <p className="mb-0"><strong>NOTE</strong>: Free for DataTalent members!</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EventCalendarPopup;